export const comments_5187250 = {"data":{"data":[],"links":{}}}